import React, {Component} from 'react'
import {Link} from 'react-router-dom';
import {Container, Row, Col, Card} from 'react-bootstrap';
import './Home.css';
import "react-multi-carousel/lib/styles.css";
import CustomNavbar from './CustomNavbar';
import LatestCarousel from './LatestCarousel';
import YoutubeCarousel from "./YoutubeCarousel";
import Footer from "./Footer";
import GibSideBar from "./GibSideBar";

let flexes = [2, 1, 1, 1, 2, 1, 2];
let minWidths = ['41vw', '21vw', '21vw', "21vw", "41vw", "21vw", "41vw"];

function ProjectsColumns(props) {
    let {appData} = props;
    const projectsList = appData.projects;
    return (

        <div style={
            {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                backgroundColor: 'white',
                marginTop: '-1.2rem',
            }
        }>
            {
                projectsList.map(function (project, idx) {
                    let projectHasImg = project.imageSource !== null && project.thumbnailSource !== null;
                    let fontColor = projectHasImg ? "white" : "#2d422b";
                    return (
                        <Card style={{
                            flex: appData.isMobile ? 1 : flexes[idx],
                            padding: 0,
                            margin: 0,
                            borderRadius: '0',
                            border: 'none',
                            minWidth: appData.isMobile ? '100vw' : minWidths[idx],
                            maxWidth: appData.isMobile ? '100vw' : '50vw',
                            minHeight: appData.isMobile ? '45vh' : '0vh',

                        }}>
                            <Card.Img variant="top" src={appData.isMobile ? project.thumbnailSource : flexes[idx] === 2 ? project.imageSource : project.thumbnailSource}
                                      style={{margin: 0, padding: 0, borderRadius: '0', border: 'none'}}/>
                            <Card.ImgOverlay style={{
                                borderRadius: '0',
                                border: 'none'
                            }}>
                                <Card.Title
                                    style={{
                                        marginTop: projectHasImg ? '-3vh' : appData.isMobile ? '-3vh' : '-3vh',
                                        color: fontColor,
                                        marginLeft: '-2.2vh',
                                        marginRight: appData.isMobile ? '0vh' : '-2.2vh'
                                    }}>
                                    <Link style={{
                                        color: fontColor,
                                        fontWeight: 'bold',
                                        fontSize: appData.isMobile ? '2.5rem' : '2.9rem',
                                        // textAlign: "center",
                                    }} to='/projects' onClick={() => appData.selectedProjectIdx = idx}>
                                    {project.title.toUpperCase().split(" ").map(function (titleWord, idx) {
                                        return (<p style={{marginBottom: '-0.5vh'}}>{titleWord}</p>);
                                    })}
                                    </Link>
                                    </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    );
                })
            }
        </div>
    );
}

export default class Home extends Component {

    nextPath(path) {
        this.props.history.push(path);
    };

    constructor(props) {
        super(props);
        this.nextPath = this.nextPath.bind(this);
    }

    render() {
        let {appData} = this.props;
        return (
            <Container style={{padding: 0, marginTop: '-1.2rem'}} fluid>
                <CustomNavbar appData={appData} initColor="#000000BF"/>
                <LatestCarousel appData={appData}/>
                <ProjectsColumns appData={appData}/>
                <Row className="show-grid text-center">
                    <Col>
                        <YoutubeCarousel appData={appData}/>
                    </Col>
                </Row>
                <Footer/>
                <GibSideBar/>
            </Container>)

    }
}
